import { Trial, ResponseStatus, ConfigurationTrial } from "@/api/dtos";
import { createContext } from "react"

export interface IConfigurationSourceDataFormContext {
    baseRoute?: string;
}

export const ConfigurationSourceDataFormContext = createContext<IConfigurationSourceDataFormContext>({
    
});

export default ConfigurationSourceDataFormContext;